module.exports = __webpack_public_path__ + "img/RedMissile-Bag300-250.3f1c84e3.jpg";